import PropTypes from 'prop-types';
import React from 'react';

import classnames from 'classnames';
import style from './style.module.scss';

class Loading extends React.PureComponent {
  static defaultProps = {
    size: 30,
    className: '',
  };

  static propTypes = {
    size: PropTypes.number,
    className: PropTypes.string,
    classNameBlade: PropTypes.string,
  };

  render() {
    const { className, classNameBlade, size, skin } = this.props;

    const inline = {
      width: size + 'px',
      height: size + 'px',
    };

    const skinsMap = {
      light: style.light,
    };

    const classNameLoading = {
      spinner: classnames(style.spinner, skinsMap[skin], className),
      spinnerBlade: classnames(style.spinnerBlade, skinsMap[skin], classNameBlade),
    };

    return (
      <div
        className={classNameLoading.spinner}
        style={inline}
        data-e2e="load_spinner"
        data-testid="loading"
      >
        <div className={classNameLoading.spinnerBlade} />
        <div className={classNameLoading.spinnerBlade} />
        <div className={classNameLoading.spinnerBlade} />
        <div className={classNameLoading.spinnerBlade} />
        <div className={classNameLoading.spinnerBlade} />
        <div className={classNameLoading.spinnerBlade} />
        <div className={classNameLoading.spinnerBlade} />
        <div className={classNameLoading.spinnerBlade} />
        <div className={classNameLoading.spinnerBlade} />
        <div className={classNameLoading.spinnerBlade} />
        <div className={classNameLoading.spinnerBlade} />
        <div className={classNameLoading.spinnerBlade} />
      </div>
    );
  }
}

export { Loading };
